import { BaseFilter } from './BaseFilter.js'

/**
 * UI-based filter that doesn't affect data but modifies visual appearance
 */
export class UIFilter extends BaseFilter {
	constructor(id, label, active = false) {
		super(id, label, active)
		this.type = 'ui'
	}

	/**
	 * UI filters don't filter data, they just track state
	 * @param {any} item 
	 * @param {Object} context 
	 * @returns {boolean} - Always returns true (no data filtering)
	 */
	apply(item, context = {}) {
		return true
	}
}

/**
 * Filter to control dimming of non-owned bookings
 */
export class DimOtherBookingsFilter extends UIFilter {
	constructor(active = true) {
		super('dim-other-bookings', 'Fremde Buchungen abdunkeln', active)
	}
}